import ButtonComp from "@components/UI/Button/Index";
import { useSubmitSolicitacao } from "@hooks/functions/Solicitacao/Admin/useSubmitSolicitacao";

function ButtonActions({
    selectedRow,
    solicitacaoProcessoItems,
    methods,
    setCodigoCompliance,
    setSolicitacaoProcessoItems,
    setSelectedRow,
}) {

    const { onSubmit } = useSubmitSolicitacao({
        selectedRow,
        solicitacaoProcessoItems,
        methods,
        setCodigoCompliance,
        setSolicitacaoProcessoItems,
        setSelectedRow,
    });

    return (
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
            <div className="row mt-4">
                <div className="col-12 col-md-12">
                    <div className="block h-auto">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex justify-content-center gap-2">

                                        <ButtonComp
                                            title={"SALVAR"}
                                            type={"submit"}
                                            buttonColor={"#2b97be"}
                                            classnameIcon={"fa-regular fa-floppy-disk"}
                                            hoverMessage={"Botão para salvar a solicitação"}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ButtonActions;